/**
 * Company countersign is not a live Contracts permission. Owner always may
 * sign. Leftover `perm-contract-sign` still counts (folded into VIEW).
 * An authorized Administrator picks the roster in Settings → Electronic Signature.
 * Empty roster = not set yet — hold-harmless so the existing sale path
 * (sales-rep countersign) still works until someone picks people.
 */
export const CONTRACT_SIGN_LEFTOVER = 'perm-contract-sign';

export function canCompanyCountersign(opts: {
  userId?: string | null;
  isOwner?: boolean;
  isAdmin?: boolean;
  authorizedSignerUserIds?: string[] | null;
  leftoverSign?: boolean;
  canViewContract?: boolean;
}): boolean {
  if (opts.isOwner) return true;
  if (opts.leftoverSign) return true;
  const roster = (opts.authorizedSignerUserIds ?? []).filter(Boolean);
  // Empty roster: any logged-in staff who can already see the contract.
  if (roster.length === 0) return opts.canViewContract !== false;
  return !!opts.userId && roster.includes(opts.userId);
}
